import * as React from 'react';

import { FormParserContext } from 'src/contexts/form.context';
import { AutoCompleteDomains, AutoCompleteResult, Maybe } from 'src/models';
import { TradesAutoComplete as TradesAutoCompleteComponent } from 'src/components/InputRenderers/TradesAutoComplete';
import { InputContext } from 'src/contexts/input.context';
import { ifTrue } from 'src/tools/logic.tools';

interface Props {
  domain?: AutoCompleteDomains.PROJ_COMPANY_TRADES | AutoCompleteDomains.TRADES_NAVBAR;
}

export function TradesAutoComplete({ domain = AutoCompleteDomains.PROJ_COMPANY_TRADES }: Props) {
  const { value, script, onChange, readData: companyId, writeData = [], error } = React.useContext(FormParserContext);

  const [setCSICode, setCSIDescription] = writeData;

  function handleOnChange(result: Maybe<AutoCompleteResult>) {
    onChange(result?.id);

    if (setCSICode) setCSICode(result?.sub_label);

    if (setCSIDescription) setCSIDescription(result?.icon_url);
  }

  return (
    <InputContext.Provider
      value={{
        classNames: { container: 'w-100p', input: ifTrue(error, 'with-error') },
        value,
        onChange: handleOnChange,
        isDisabled: script.isDisabled || (!companyId && domain === AutoCompleteDomains.PROJ_COMPANY_TRADES),
        isAutoFocus: script.autofocus,
        placeholder: script.placeholder,
        customization: {
          companyId,
        },
      }}
    >
      <TradesAutoCompleteComponent />
    </InputContext.Provider>
  );
}
